/**
 * @typedef {mumms.patient} PatientHeader
 *
 * @typedef PrintPatient
 * @prop {string} firstName
 * @prop {string} lastName
 * @prop {string} patientNumber
 * @prop {string} dateOfBirth
 * @prop {string} hospiceName
 * @prop {number|string|undefined} siteId
 */

/**
 * Map a PIM patient header (`mumms.patient`) into the shape the printing
 * service middleware expects for coversheet + pdf header (see
 * pdfUtils.drawHeader). Input is guaranteed to be `mumms.patient`-shaped by
 * `loadPatientVerbalApprovalsForPrint` / `loadBulkUnsignedVerbalsForPrint`.
 *
 * @param {PatientHeader | null | undefined} header
 * @returns {PrintPatient | null}
 */
export function patientHeaderToPrintPatient(header) {
  if (!header) return null;
  return {
    firstName: header.firstName ?? '',
    lastName: header.lastName ?? '',
    patientNumber: String(header.patientNumber ?? ''),
    dateOfBirth: header.dateOfBirth ?? '',
    hospiceName: header.hospiceName ?? '',
    siteId: header.siteId,
  };
}
